/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio Appointments API
 * API for managing appointments (afspraken) within an organization. All operations are scoped to the authenticated user\'s organization.  ## Session Types  The API supports four types of sessions:  ### Individual Sessions Standard one-on-one appointments with a single client and behandelaar. Use `clientId` for single client appointments.  ### Group Sessions (explicit clients) Appointments with multiple clients (e.g., group therapy, family sessions). Use `clientIds` array to specify multiple clients. Each client gets individual attendance tracking and billable quarters calculation.  ### Client Group Sessions (dynamic membership) Appointments linked to a Client Group. The participating clients are determined dynamically based on who is a member of the group on the appointment date. Use `groupId` to assign a client group. For recurring appointments, each instance resolves members independently based on its own `startTime`.  When `groupId` is set, the `clientIds` field is ignored (the group determines clients). The response includes: - `group`: Basic group info (id, name) - `participants`: Clients who are members of the group on the appointment date   (each entry carries `clientId`, `clientName`, and membership dates)  ### Multidisciplinary Sessions Appointments with multiple behandelaren (e.g., MDO - multidisciplinair overleg). Use `attendeeIds` array to add additional behandelaren beyond the primary `behandelaarId` (who becomes the organizer).  ### Internal Meetings Team meetings without clients. Use `category: \"INTERNAL\"` and omit client fields.  ## All-Day Appointments  All-day appointments (e.g., daily stay costs in residential care) span the entire day. Set `isAllDay: true` to create an all-day appointment. When `isAllDay` is true: - `startTime` should be set to the start of the day (00:00 / midnight) - `endTime` should be set to the end of the same day (23:59) - `durationMinutes` reads 1439 — the span is 00:00:00.000 through 23:59:59.999,   and the response derives the duration from those two times rather than storing it  All-day appointments are backwards compatible: existing appointments default to `isAllDay: false`. Note: multi-day appointments (spanning multiple days) are not currently supported.  ## Billable Quarters  For group sessions, each client\'s attendance is tracked individually: - `scheduledStartTime` / `scheduledEndTime` - copied from appointment - `actualStartTime` / `actualEndTime` - set during attendance registration - `billableQuarters` - auto-calculated as ceil(actualMinutes / 15)  Integrates with FullCalendar for calendar UI (see ADR-006). 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost:8080".replace(/\/+$/, "");

export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

export const operationServerMap: ServerMap = {
}
